module.exports = __webpack_public_path__ + "img/icon_feedback.e196c19a.svg";